import LegalLayout from "../components/LegalLayout";

export default function CancellationPolicy() {
  return (
    <LegalLayout title="Cancellation Policy" updated="27 September 2026">
      <p>This policy explains how cancellations work for Groundwork TierUp subscriptions and applies alongside our <a href="/terms">Terms of Service</a>.</p>

      <h2>Cancel anytime</h2>
      <p>
        There&rsquo;s no lock-in contract. You can cancel your Groundwork TierUp subscription at any time from your account settings, or
        by emailing <a href="mailto:hello@groundworktierup.com.au">hello@groundworktierup.com.au</a>.
      </p>

      <h2>When cancellation takes effect</h2>
      <p>
        When you cancel, your subscription remains active and you&rsquo;ll retain full access to the platform until the end of your
        current billing period (monthly or annual, depending on your plan). You will not be charged again after that period ends.
      </p>

      <h2>Refunds</h2>
      <p>
        We don&rsquo;t offer refunds or credits for the unused portion of a billing period. For example, if you cancel partway through a
        paid month or year, you&rsquo;ll retain access until that period ends, but the remaining time isn&rsquo;t refunded. If you
        believe there&rsquo;s a billing error or an exceptional circumstance, contact{" "}
        <a href="mailto:hello@groundworktierup.com.au">hello@groundworktierup.com.au</a> and we&rsquo;ll review it on a case-by-case
        basis.
      </p>

      <h2>What happens to your data</h2>
      <p>
        After your subscription ends, your account and project data are retained so you can reactivate later without losing your
        work. We don&rsquo;t currently delete it automatically on a fixed schedule. If you&rsquo;d like your data deleted or exported,
        email <a href="mailto:hello@groundworktierup.com.au">hello@groundworktierup.com.au</a> and we&rsquo;ll action that for you
        directly.
      </p>

      <h2>Failed or declined payments</h2>
      <p>
        If a renewal payment fails, your access is suspended immediately while we retry the charge. If the retry succeeds, access is
        restored automatically. If you need help resolving a failed payment, email{" "}
        <a href="mailto:hello@groundworktierup.com.au">hello@groundworktierup.com.au</a>.
      </p>

      <h2>Reactivating</h2>
      <p>
        You can reactivate a cancelled subscription at any time from your account settings, and billing resumes from the date you
        reactivate.
      </p>

      <h2>Questions</h2>
      <p>
        If you&rsquo;re not sure how any of this applies to your plan, email{" "}
        <a href="mailto:hello@groundworktierup.com.au">hello@groundworktierup.com.au</a> before you cancel, we&rsquo;re happy to
        talk it through.
      </p>
    </LegalLayout>
  );
}
